module.exports = __webpack_public_path__ + "img/discord.f8389ca1.svg";